import React, { useState, useEffect } from 'react';
import api from '../api';

export default function WelfareCheckModal({ user }) {
  const http = api();
  const [pending, setPending] = useState(null);
  const [responding, setResponding] = useState(false);
  const [done, setDone] = useState(false);
  const [wasSOS, setWasSOS] = useState(false);

  useEffect(() => {
    if (!user || user.role !== 'worker') return;
    const check = async () => {
      try {
        const res = await http.get('/welfare/pending');
        if (res.data) setPending(res.data);
      } catch { /* silent */ }
    };
    check();
  }, [user]);

  const respond = async (status) => {
    if (!pending) return;
    setResponding(true);
    try {
      const hireId = pending.data?.hire_id || (typeof pending.data === 'string' ? JSON.parse(pending.data)?.hire_id : null);
      if (hireId) {
        await http.post(`/hires/${hireId}/welfare-checkin`, { status });
      }
      setWasSOS(status === 'sos');
      setDone(true);
    } catch { /* graceful */ }
    finally { setResponding(false); }
  };

  const dismiss = () => setPending(null);

  if (!pending || !user || user.role !== 'worker') return null;

  return (
    <div className="fixed inset-0 z-50 bg-black/60 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-sm w-full p-6 text-center">
        {!done ? (
          <>
            <div className="text-5xl mb-4">👋</div>
            <h2 className="text-xl font-extrabold text-neutral-900 mb-2">Are you okay?</h2>
            <p className="text-sm text-neutral-500 mb-1">
              You've been on shift for a while.
            </p>
            {pending.data?.shift_title && (
              <p className="text-xs text-neutral-400 mb-6 font-medium">📋 {pending.data.shift_title}</p>
            )}
            <div className="flex gap-3">
              <button
                onClick={() => respond('ok')}
                disabled={responding}
                className="flex-1 py-4 bg-green-500 hover:bg-green-600 text-white font-extrabold text-lg rounded-2xl transition disabled:opacity-50 shadow-sm"
              >
                ✅ All Good
              </button>
              <button
                onClick={() => respond('sos')}
                disabled={responding}
                className="flex-1 py-4 bg-red-500 hover:bg-red-600 text-white font-extrabold text-lg rounded-2xl transition disabled:opacity-50 shadow-sm"
              >
                🆘 Need Help
              </button>
            </div>
            <button onClick={dismiss} className="mt-4 text-xs text-neutral-400 hover:text-neutral-600 transition">
              Dismiss
            </button>
          </>
        ) : wasSOS ? (
          <>
            <div className="text-5xl mb-4">🆘</div>
            <h2 className="text-xl font-extrabold text-red-600 mb-2">Help is on the way</h2>
            <p className="text-sm text-neutral-600 mb-4">
              Your employer has been alerted. Stay where you are.
            </p>
            <div className="bg-red-50 border border-red-200 rounded-xl p-3 mb-4">
              <p className="text-sm font-bold text-red-700">Emergency: Call 000</p>
              <a href="tel:000" className="text-lg font-extrabold text-red-600 hover:underline">📞 000</a>
            </div>
            <button onClick={dismiss} className="w-full py-3 bg-neutral-100 text-neutral-700 font-semibold rounded-xl hover:bg-neutral-200 transition">
              Close
            </button>
          </>
        ) : (
          <>
            <div className="text-5xl mb-4">✅</div>
            <h2 className="text-xl font-extrabold text-green-600 mb-2">Great — stay safe!</h2>
            <p className="text-sm text-neutral-500 mb-4">Welfare check recorded. Keep up the good work.</p>
            <button onClick={dismiss} className="w-full py-3 bg-brand-500 text-white font-bold rounded-xl hover:bg-brand-600 transition">
              Continue
            </button>
          </>
        )}
      </div>
    </div>
  );
}
